import { QA_NAME_TEXT_DEFAULT } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'

function TagTextLine({
  className,
  overflowRef,
  placement,
  qaName,
  text,
  tooltipDisabled,
}) {
  const qaProps = qaName
    ? getQaSelector({ context: QA_NAME_TEXT_DEFAULT, value: qaName })
    : undefined

  return (
    <FloatingTooltip
      content={text}
      disabled={tooltipDisabled}
      placement={placement}
    >
      <span {...qaProps} className={className} ref={overflowRef}>
        {text}
      </span>
    </FloatingTooltip>
  )
}

export default TagTextLine
